import { Component } from '@angular/core';
import { StageSchema } from '@lsq-frontend/remote-services/ar-app';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { getDynamicRouteLink, getRouterLinkUrlById } from '@lsq-frontend/common-ui';
import { atlas, VIEW_DOCUMENTS } from '@lsq-frontend/fasttrack-shared/routing-atlas';

@Component({
    selector: 'documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss']
})
export class ViewDocumentsComponent {
    public companyKey: string;
    public isLoading: boolean;
    public stageSchema: StageSchema;
    public stageData;
    public noData: boolean = false;
    public dynamicRouterLink;

    constructor(private fb: FormBuilder, private _userService: UserService) {}
    public async ngOnInit(): Promise<void> {
        this._userService.user$.subscribe(async (user) => {
            this.companyKey = user.currentCompany.companyKey;
        });
        this.getDyamnicRouterLink();
    }

    public formGroup: FormGroup = this.fb.group({});

    public getDyamnicRouterLink() {
        this.dynamicRouterLink = getDynamicRouteLink(
            getRouterLinkUrlById(atlas, VIEW_DOCUMENTS),
            {}
        );
    }
}
